import { create } from "zustand";
import { persist } from "zustand/middleware";

import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from "@/config/i18n.config";
import { Locale, LocaleConfig } from "@/types/i18n.types";

interface LocaleStore {
  currentLocale: Locale;
  localeConfig: LocaleConfig;
  setLocale: (locale: Locale) => void;
}

export const useLocaleStore = create<LocaleStore>()(
  persist(
    (set) => ({
      currentLocale: DEFAULT_LOCALE,
      localeConfig: (SUPPORTED_LOCALES[DEFAULT_LOCALE] as LocaleConfig),
      setLocale: (locale: Locale) =>
        set({
          currentLocale: locale,
          localeConfig: SUPPORTED_LOCALES[locale]
        })
    }),
    {
      name: "locale-storage",
      partialize: (state) => ({ currentLocale: state.currentLocale })
    }
  )
);
